import Alpine from "alpinejs";
import gsap from "gsap";

export const interviewSingleAnimation = () => {
  Alpine.data("interviewSingleAnimation", () => ({
    timeline: null as gsap.core.Timeline | null,
    init() {
      const enLabel = this.$refs.enLabel as HTMLElement | null;
      const title = this.$refs.title as HTMLElement | null;
      const name = this.$refs.name as HTMLElement | null;
      const comment = this.$refs.comment as HTMLElement | null;
      const imageWrapper =
        (this.$refs.img as HTMLElement | null) ?? (this.$refs.image as HTMLElement | null);
      const image = imageWrapper?.querySelector("img") as HTMLElement | null;

      if (!enLabel && !title && !name && !comment && !image) return;

      const chars = enLabel
        ? (Array.from(enLabel.querySelectorAll(".js-interview-single-char")) as HTMLElement[])
        : [];

      if (chars.length > 0) {
        gsap.set(chars, { autoAlpha: 0, x: 16 });
        gsap.set(title, { autoAlpha: 0, y: 8 });
        gsap.set(name, { autoAlpha: 0, y: 8 });
        gsap.set(comment, { autoAlpha: 0 });
        gsap.set(image, {
          autoAlpha: 0.2,
          scale: 1.1,
          transformOrigin: "50% 50%",
        });
      }

      const tl = gsap.timeline();

      tl.to(image, {
        autoAlpha: 1,
        scale: 1,
        duration: 1.4,
        ease: "power2.out",
      })
        .to(
          chars,
          {
            x: 0,
            autoAlpha: 1,
            duration: 0.6,
            stagger: 0.05,
            ease: "power2.out",
          },
          0,
        )
        .to(
          title,
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.8,
            ease: "power2.out",
          },
          0,
        )
        .to(
          name,
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.8,
            ease: "power2.out",
          },
          0,
        )
        .to(
          comment,
          {
            autoAlpha: 1,
            duration: 0.8,
            ease: "power2.out",
          },
          "-=1.2",
        );

      this.timeline = tl;
    },
    destroy() {
      this.timeline?.kill();
      this.timeline = null;
    },
  }));
};
